import { useArchiveDataQuery } from 'js/file_viewer/core/queries/riviera_preview_types/archive';
export const useArchiveEntry = (rootPreviewKey, rootPreviewMetadata, currentPath) => {
    var _a;
    const result = useArchiveDataQuery(rootPreviewKey, rootPreviewMetadata);
    if (!currentPath) {
        return undefined;
    }
    const entries = (_a = result.data) === null || _a === void 0 ? void 0 : _a.apiData.entries;
    return entries === null || entries === void 0 ? void 0 : entries[currentPath];
};
//# sourceMappingURL=archive.preenvesnextjs.map
